/* eslint-disable no-unused-vars */
/* eslint-disable no-unneeded-ternary */
/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable react/no-array-index-key */
/* eslint-disable no-nested-ternary */
import React, { useState } from 'react';
import { useQuery } from '@apollo/client';
import { Button } from 'reactstrap';
import { ADD_EDIT_CONSTANT, defaultDeleteFilter } from 'utils/constants';
import { ADDITIONAL_VENDORS_QUERY } from 'pages/Vendor/VendorGraphQL';
import ProfileNameCard from 'components/ProfileNameCard';
import { HiPlus } from 'react-icons/hi';
import FSBModal from 'components/common/FSBModal';
import Loader from 'components/common/Loader';
import CardWithTitle from 'components/CardWithTitle';
import AdditionalUser from './components/AdditionalUser';

const VendorAdditionalUser = ({ currentRow }) => {
  const [filters, setFilters] = useState({
    filter: [
      { key: 'parentTrader', value: currentRow?.id, type: 'INT', op: 'EQ' },
      { ...defaultDeleteFilter },
    ],
    pagination: false,
  });

  const { data, loading, error, refetch } = useQuery(ADDITIONAL_VENDORS_QUERY, {
    variables: {
      ...filters,
      filter: [...filters.filter],
    },
    fetchPolicy: 'network-only',
  });

  const [showUserLimit, setShowUserLimit] = useState(false);
  const [showAdditionalUser, setShowAdditionalUser] = useState({
    status: false,
    row: currentRow,
    type: ADD_EDIT_CONSTANT.ADD,
  });

  const toggleAdditonalUserLimit = () => {
    setShowUserLimit(!showUserLimit);
  };
  const toggleAdditonalUser = (row, type) => {
    if (
      currentRow?.userSubscription?.userLimit <= data?.traders?.traders.length
    ) {
      toggleAdditonalUserLimit();
    } else {
      setShowAdditionalUser({ status: !showAdditionalUser.status, row, type });
    }
  };

  if (loading) return <Loader />;
  if (error) return `There is an error on this page : ${error.message} `;
  if (!data?.traders?.traders) return 'Traders not available';

  return (
    <>
      {currentRow?.isParentTrader && currentRow?.userSubscription?.id ? (
        <CardWithTitle title="Additional User">
          {showUserLimit && (
            <FSBModal
              size="xl"
              title="User Limit"
              closeButtonLabel=""
              confirmButtonLabel=""
              message="User's additional user limit exceeded! Please purchase an additional user Add on!"
              open={showUserLimit}
              toggleAlert={toggleAdditonalUserLimit}
              onClose={toggleAdditonalUserLimit}
            />
          )}
          {showAdditionalUser.status && (
            <FSBModal
              size="xl"
              title="Subscribe"
              closeButtonLabel=""
              confirmButtonLabel=""
              message=""
              open={showAdditionalUser.status}
              toggleAlert={toggleAdditonalUser}
              onClose={toggleAdditonalUser}
              modalClass="right-drawer right-drawer-details"
            >
              <AdditionalUser
                currentRow={currentRow}
                type={showAdditionalUser.type}
                drawerToggle={toggleAdditonalUser}
                refetch={refetch}
              />
            </FSBModal>
          )}
          {data?.traders?.traders.length ? (
            <div className="additional-user-row align-items-start overflow-x-auto d-flex flex-nowrap text-nowrap">
              {data?.traders?.traders.map((user, index) => (
                <div
                  key={index}
                  className={`me-4 pe-3 mb-4 user-col ${user?.status === 'INACTIVE' ? 'card-blur' : ''}`}
                >
                  <ProfileNameCard
                    wrapperClass=""
                    profile={null}
                    fname={user?.firstName ? user?.firstName[0] : ''}
                    lname={user?.lastName ? user?.lastName[0] : ''}
                  />
                  <div className="mt-1">
                    <p className="f-14 text-dark-525 fw-medium mb-0">
                      {user?.firstName} {user?.lastName}
                    </p>
                    <p className="f-12 mb-0 text-active fw-medium">
                      {user?.email}
                    </p>
                    <p className="f-12 mb-0 text-active fw-medium">
                      {`${user?.callingCode?.callingCode}-${user?.phone}`}
                    </p>
                  </div>
                </div>
              ))}
              <Button
                className="bg-transparent border-0 user-add text-center"
                disabled={
                  currentRow?.kycStatus === 'KYC_ACCEPTED' ? false : true
                }
                onClick={toggleAdditonalUser}
              >
                <span className="circle d-flex mx-auto align-items-center justify-content-center rounded-circle">
                  <HiPlus size={20} color="#2378C9" />
                </span>
                <span className="f-14 text-dark-525 fw-medium mb-0">
                  Add New
                </span>
              </Button>
            </div>
          ) : (
            <Button
              className="bg-transparent border-0 user-add text-center"
              onClick={toggleAdditonalUser}
            >
              <span className="circle d-flex mx-auto align-items-center justify-content-center rounded-circle">
                <HiPlus size={20} color="#2378C9" />
              </span>
              <span className="f-14 text-dark-525 fw-medium mb-0">Add New</span>
            </Button>
          )}
        </CardWithTitle>
      ) : (
        ''
      )}
    </>
  );
};

export default VendorAdditionalUser;
